import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';

@Component({
})
export default class SliderElement extends Vue {
    @Prop() ratio!: number
    @Prop({default: ''}) src!: string
    @Prop() width!: string | number
    @Prop() height!: string | number
}